import script from "./GlobalQuillEditor.vue?vue&type=script&setup=true&lang=js"
export * from "./GlobalQuillEditor.vue?vue&type=script&setup=true&lang=js"

import "./GlobalQuillEditor.vue?vue&type=style&index=0&id=0d085fae&scoped=true&lang=css"

import exportComponent from "../../../../thejourney/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0d085fae"]])

export default __exports__